<template>
  <b-modal
    :id="idModal"
    :ref="idModal"
    size="xl"
    body-classes="p-0"
    @show="cargaModal()"
  >
    <template #modal-header="{ close }">
      <b-form-checkbox
        class="pt-3"
        v-model="modalCatecumeno.activo"
        value="1"
        unchecked-value="0"
        :disabled="isDisabled.general"
      >
        Catecumeno activo
      </b-form-checkbox>
      <button type="button" aria-label="Close" class="close" @click="close()">
        ×
      </button>
    </template>
    <b-form>
      <h6 class="heading-small text-muted mb-1">Curso</h6>
      <base-input class="">
        <b-select
          type="select"
          label="Curso"
          :options="optionsCurso"
          placeholder="Curso"
          v-model="cursoSelected"
          :disabled="isDisabled.general || modalCatecumeno.activo == 0"
          id="cursoCatequesis"
        ></b-select>
      </base-input>

      <h6 class="heading-small text-muted mb-1">Grupo</h6>

      <base-input class="mr-1">
        <b-select
          type="select"
          label="Grupo"
          :options="cursoSelected"
          placeholder="Grupo"
          v-model="modalCatecumeno.id_grupo_catequesis"
          :disabled="isDisabled.general || modalCatecumeno.activo == 0"
        ></b-select>
      </base-input>

      <hr class="mt-0 mb-1" />

      <h6 class="heading-small text-muted mb-4">Datos Catecumeno</h6>

      <div>
        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Nombre"
              placeholder="Nombre"
              v-model="modalCatecumeno.nombre"
              :disabled="isDisabled.general"
              :required="true"
            >
            </base-input>
          </b-col>

          <b-col>
            <base-input
              type="text"
              label="Primer Apellido"
              placeholder="Primer Apellido"
              v-model="modalCatecumeno.apellido1"
              :disabled="isDisabled.general"
              :required="true"
            >
            </base-input>
          </b-col>

          <b-col>
            <base-input
              type="text"
              label="Segundo Apellido"
              placeholder="Segundo Apellido"
              v-model="modalCatecumeno.apellido2"
              :disabled="isDisabled.general"
            >
            </base-input>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <base-input
              type="date"
              label="Fecha de Nacimiento"
              locale="es"
              v-model="modalCatecumeno.fecha_nacimiento"
              :disabled="isDisabled.general"
            >
            </base-input>
          </b-col>
          <b-col>
            <h6 class="heading-small text-muted mb-1">Colegio</h6>

            <b-select
              type="select"
              label="Colegio"
              :options="listaColegios"
              placeholder="Colegio"
              v-model="modalCatecumeno.id_colegio"
              :disabled="isDisabled.general"
            ></b-select>
          </b-col>

          <b-col>
            <h6 class="heading-small text-muted mb-1">Curso Escolar</h6>

            <b-select
              type="select"
              label="Curso Escolar"
              :options="listaCursosEscolar"
              placeholder="Curso Escolar"
              v-model="modalCatecumeno.id_curso_colegio"
              :disabled="isDisabled.general"
            ></b-select>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Situación Familiar"
              placeholder="Situación Familiar"
              v-model="modalCatecumeno.situacion_familiar"
              :disabled="isDisabled.general"
            >
            </base-input>
          </b-col>

          <b-col>
            <base-input
              type="text"
              label="Nº Hermanos"
              placeholder="Nº Hermanos"
              v-model="modalCatecumeno.numero_hermanos"
              :disabled="isDisabled.general"
            >
            </base-input>
          </b-col>

          <b-col>
            <base-input
              type="text"
              label="Lugar que ocupa"
              placeholder="Lugar que ocupa"
              v-model="modalCatecumeno.lugar_ocupa_hermanos"
              :disabled="isDisabled.general"
            >
            </base-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Profesión"
              placeholder="Profesión"
              v-model="modalCatecumeno.profesion"
              :disabled="isDisabled.general"
            >
            </base-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Domicilio"
              placeholder="Domicilio"
              v-model="modalCatecumeno.domicilio"
              :disabled="isDisabled.general"
            >
            </base-input>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col>
            <base-input
              type="file"
              label="Foto"
              placeholder="Nombre"
              accept=".pdf,.png,.jpg"
              v-model="foto.document"
              @change="uploadFile($event, 'foto')"
              :disabled="isDisabled.general"
            >
            </base-input>
            <article v-if="foto.isImage">
              <button
                type="button"
                aria-label="Close"
                class="close"
                @click="clean('foto')"
              >
                ×
              </button>
              <img style="max-width: 20rem" :src="foto.src" />
            </article>
          </b-col>

          <b-col>
            <b-form-group label="Partida de Bautismo">
              <b-form-radio
                v-model="modalCatecumeno.bautizo.entregada"
                name="partidas-bautismo"
                :value="1"
                >Si</b-form-radio
              >

              <b-form-radio
                v-model="modalCatecumeno.bautizo.entregada"
                name="partidas-bautismo"
                :value="0"
                >No</b-form-radio
              >
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="modalCatecumeno.bautizo.entregada == 1">
          <b-col>
            <h6 class="heading-small text-muted mb-4">Datos de Bautismo</h6>
            <base-input
              type="text"
              label="Parroquia de Bautismo"
              placeholder="Parroquia de Bautismo"
              v-model="modalCatecumeno.bautizo.nombreParroquia"
              :disabled="isDisabled.general"
            />
            <b-row>
              <b-col>
                <base-input
                  type="date"
                  locale="es"
                  label="Fecha de Bautismo"
                  placeholder="Fecha de Bautismo"
                  v-model="modalCatecumeno.bautizo.fecha"
                  :disabled="isDisabled.general"
                />
              </b-col>
              <b-col>
                <base-input
                  type="text"
                  label="Municipio"
                  placeholder="Municipio"
                  v-model="modalCatecumeno.bautizo.municipio"
                  :disabled="isDisabled.general"
                />
              </b-col>
              <b-col>
                <base-input
                  type="text"
                  label="Provincia"
                  placeholder="Provincia"
                  v-model="modalCatecumeno.bautizo.provincia"
                  :disabled="isDisabled.general"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <base-input
                  type="text"
                  label="Libro"
                  placeholder="Libro"
                  v-model="modalCatecumeno.bautizo.libro"
                  :disabled="isDisabled.general"
                />
              </b-col>
              <b-col>
                <base-input
                  type="text"
                  label="Folio"
                  placeholder="Folio"
                  v-model="modalCatecumeno.bautizo.folio"
                  :disabled="isDisabled.general"
                />
              </b-col>
              <b-col>
                <base-input
                  type="text"
                  label="Numero"
                  placeholder="Numero"
                  v-model="modalCatecumeno.bautizo.numero"
                  :disabled="isDisabled.general"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <hr class="my-4" />
      <h6 class="heading-small text-muted mb-4">Datos de los Padres</h6>

      <b-form-group label="¿Ha apuntado a algun otro hijo a Catequesis?">
        <b-form-radio
          v-model="selected"
          @change="
            isDisabled.padres = true;
            autoPadre('');
            autoMadre('');
          "
          name="some-radios"
          :value="1"
          :disabled="isDisabled.general || isDisabled.radioPadres"
          >Si</b-form-radio
        >

        <b-form-radio
          v-model="selected"
          @change="
            isDisabled.padres = false;
            autoPadre('');
            autoMadre('');
          "
          name="some-radios"
          :value="2"
          :disabled="isDisabled.general || isDisabled.radioPadres"
          >No</b-form-radio
        >
      </b-form-group>

      <div v-if="selected == 1 || selected == 2">
        <b-row v-if="selected == 1">
          <b-col>
            <h6 class="heading-small text-muted">
              Apellidos y Nombre del Padre
            </h6>

            <vue-bootstrap-typeahead
              placeholder="Apellidos y Nombre del Padre"
              v-model="autocompletePadre"
              :data="listaPadres"
              @input="autoPadre(autocompletePadre)"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Nombre del Padre"
              placeholder="Nombre del Padre"
              v-model="modalCatecumeno.padre.nombre"
              :disabled="isDisabled.padres"
            >
            </base-input>
          </b-col>

          <b-col>
            <base-input
              type="text"
              label="Primer apellido del padre"
              placeholder="Primer apellido del padre"
              v-model="modalCatecumeno.padre.apellido1"
              :disabled="isDisabled.padres"
            >
            </base-input>
          </b-col>

          <b-col>
            <base-input
              type="text"
              label="Segundo apellido del padre"
              placeholder="Segundo apellido del padre"
              v-model="modalCatecumeno.padre.apellido2"
              :disabled="isDisabled.padres"
            >
            </base-input>
          </b-col>

          <b-col>
            <base-input
              type="date"
              label="Fecha nacimiento Padre"
              locale="es"
              v-model="modalCatecumeno.padre.fecha_nacimiento"
              :disabled="isDisabled.padres"
            >
            </base-input>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Profesión del padre"
              placeholder="Profesión del padre"
              v-model="modalCatecumeno.padre.profesion"
              :disabled="isDisabled.padres"
            >
            </base-input>
          </b-col>

          <b-col>
            <base-input
              type="text"
              label="Telefono del Padre"
              placeholder="Telefono del Padre"
              v-model="modalCatecumeno.padre.telefono"
              :disabled="isDisabled.padres"
            >
            </base-input>
          </b-col>
        </b-row>

        <hr class="my-4" />

        <b-row v-if="selected == 1">
          <b-col>
            <h6 class="heading-small text-muted">
              Apellidos y Nombre de la Madre
            </h6>

            <vue-bootstrap-typeahead
              placeholder="Apellidos y Nombre de la Madre"
              v-model="autocompleteMadre"
              :data="listaMadres"
              @input="autoMadre(autocompleteMadre)"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Nombre de la Madre"
              placeholder="Nombre de la Madre"
              v-model="modalCatecumeno.madre.nombre"
              :disabled="isDisabled.padres"
            >
            </base-input>
          </b-col>
          <b-col>
            <base-input
              type="text"
              label="Primer apellido de la madre"
              placeholder="Primer apellido de la madre"
              v-model="modalCatecumeno.madre.apellido1"
              :disabled="isDisabled.padres"
            >
            </base-input>
          </b-col>
          <b-col>
            <base-input
              type="text"
              label="Segundo apellido de la Madre"
              placeholder="Segundo apellido de la Madre"
              v-model="modalCatecumeno.madre.apellido2"
              :disabled="isDisabled.padres"
            >
            </base-input>
          </b-col>
          <b-col>
            <base-input
              type="date"
              label="Fecha de nacimiento de la madre"
              locale="es"
              v-model="modalCatecumeno.madre.fecha_nacimiento"
              :disabled="isDisabled.padres"
            >
            </base-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <base-input
              type="text"
              label="Profesión de la Madre"
              placeholder="Profesión de la Madre"
              v-model="modalCatecumeno.madre.profesion"
              :disabled="isDisabled.padres"
            >
            </base-input>
          </b-col>
          <b-col>
            <base-input
              type="number"
              label="Telefono de la Madre"
              placeholder="Telefono de la Madre"
              v-model="modalCatecumeno.madre.telefono"
              :disabled="isDisabled.padres"
            >
            </base-input>
          </b-col>
        </b-row>
      </div>
      <hr class="my-2" />
      <div>
        <b-col>
          <base-input
            type="date"
            label="Fecha de inscripción"
            locale="es"
            v-model="modalCatecumeno.fecha_inscripcion"
            :disabled="isDisabled.general || isDisabled.radioPadres"
          >
          </base-input>
        </b-col>
        <b-col>
          <b-form-group
            label="Anotaciones"
            label-class="form-control-label"
            class="mb-0"
            label-for="about-form-textaria"
            :disabled="isDisabled.general"
          >
            <b-form-textarea
              rows="4"
              v-model="modalCatecumeno.observaciones"
              id="about-form-textaria"
              placeholder="Anotaciones"
              :disabled="isDisabled.general"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </div>
    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          :disabled="isDisabled.guardaDatos"
          variant="primary"
          size="sm"
          class="float-right"
          @click="
            guardaCatecumeno(),
              (isDisabled.guardaDatos = !isDisabled.guardaDatos)
          "
        >
          Guardar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import BaseButton from "../BaseButton.vue";
import swal from "sweetalert2";
import imageCompression from 'browser-image-compression';

import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  name: "modalCatecumeno",
  components: {
    VueBootstrapTypeahead,
    BaseButton,
  },
  props: ["idModal", "catecumeno"],
  data() {
    return {
      autocompleteMadre: "",
      autocompletePadre: "",
      cursoSelected: null,
      foto: {
        isImage: false,
        src: undefined,
        name: undefined,
        type: undefined,
        document: undefined,
      },
      isDisabled: {
        padres: true,
        general: false,
        radioPadres: false,
        guardaDatos: false,
      },
      selected: undefined,
      modalCatecumeno: {
        id: undefined,
        activo: undefined,
        nombre: undefined,
        apellido1: undefined,
        apellido2: undefined,
        fecha_nacimiento: undefined,
        numero_hermanos: undefined,
        lugar_ocupa_hermanos: undefined,
        id_colegio: undefined,
        id_curso_colegio: undefined,
        domicilio: undefined,
        observaciones: undefined,
        profesion: undefined,
        fecha_inscripcion:
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          new Date().getDate(),
        id_grupo_catequesis: undefined,
        foto: undefined,
        nombre_foto: undefined,
        bautizo: {
          nombreParroquia: undefined,
          fecha: undefined,
          municipio: undefined,
          provincia: undefined,
          libro: undefined,
          folio: undefined,
          numero: undefined,
          entregada: 0,
        },
        situacion_familiar: undefined,
        padre: {
          nombre: undefined,
          apellido1: undefined,
          apellido2: undefined,
          fecha_nacimiento: undefined,
          profesion: undefined,
          telefono: undefined,
          id: undefined,
        },
        madre: {
          nombre: undefined,
          apellido1: undefined,
          apellido2: undefined,
          fecha_nacimiento: undefined,
          profesion: undefined,
          telefono: undefined,
          id: undefined,
        },
      },
    };
  },
  watch: {
    modalCatecumeno: {
      handler(newValue) {
        if (newValue.activo == 0) {
          this.cursoSelected = null;
          this.modalCatecumeno.id_grupo_catequesis = undefined;
        }
      },
      deep: true,
    },
  },
  computed: {
    listaColegios() {
      if (this.$store.getters.getColegios != undefined) {
        if (this.$store.getters.getColegios.length > 0) {
          loader.close();
          return this.$store.getters.getColegios.map((element) => {
            return { text: element.nombre, value: element.id };
          });
        } else {
          loader.close();
          return [];
        }
      } else {
        loader.open();
        this.$store.dispatch("recargaColegiosCursos");
        return [];
      }
    },
    optionsCurso() {
      if (this.$store.getters.getCursosGruposCatequistas != undefined) {
        if (this.$store.getters.getCursosGruposCatequistas.length > 0) {
          return this.$store.getters.getCursosGruposCatequistas.map((curso) => {
            return {
              text: curso.nombre,
              value: curso.grupos.map((grupo) => {
                return {
                  text:
                    grupo.nombre_grupo +
                    (grupo.catequistas.length > 0
                      ? " - " +
                        grupo.catequistas[0].nombre +
                        " " +
                        grupo.catequistas[0].apellido1
                      : ""),
                  value: grupo.id,
                  idCurso: curso.id,
                };
              }),
              id: curso.id,
            };
          });
        } else {
          loader.close();
          return [];
        }
      } else {
        loader.open();
        this.$store.dispatch("cargarCursosGruposCatequistas");
        return [];
      }
    },
    listaMadres() {
      if (this.$store.getters.getTodasMadres != undefined) {
        if (this.$store.getters.getTodasMadres.length > 0) {
          loader.close();
          return this.$store.getters.getTodasMadres.map((element) => {
            return (
              element.nombre + " " + element.apellido1 + " " + element.apellido2
            );
          });
        } else {
          loader.close();
          return [];
        }
      } else {
        loader.open();
        this.$store.dispatch("recargaMadres");
        return [];
      }
    },
    listaPadres() {
      if (this.$store.getters.getTodosPadres != undefined) {
        if (this.$store.getters.getTodosPadres.length > 0) {
          loader.close();
          return this.$store.getters.getTodosPadres.map((element) => {
            return (
              element.nombre + " " + element.apellido1 + " " + element.apellido2
            );
          });
        } else {
          loader.close();
          return [];
        }
      } else {
        loader.open();
        this.$store.dispatch("recargaPadres");
        return [];
      }
    },
    listaCursosEscolar() {
      if (this.$store.getters.getCursosEscolares != undefined) {
        if (this.$store.getters.getCursosEscolares.length > 0) {
          loader.close();
          return this.$store.getters.getCursosEscolares.map((element) => {
            return { text: element.nombre, value: element.id };
          });
        } else {
          loader.close();
          return [];
        }
      } else {
        loader.open();
        this.$store.dispatch("recargaColegiosCursos");
        return [];
      }
    },
  },
  methods: {
    resetDatos() {
      this.autocompleteMadre = "";
      this.autocompletePadre = "";
      this.cursoSelected = null;
      (this.file = {
        isImage: false,
        src: null,
        name: null,
        type: null,
        document: null,
      }),
        (this.foto = {
          isImage: false,
          src: null,
          name: null,
          type: null,
          document: null,
        });
      this.isDisabled = {
        padres: true,
        general: false,
        radioPadres: false,
        guardaDatos: false,
      };
      this.selected = null;
      this.modalCatecumeno = {
        id: null,
        activo: 1,
        nombre: null,
        apellido1: null,
        apellido2: null,
        fecha_nacimiento: null,
        numero_hermanos: null,
        lugar_ocupa_hermanos: null,
        id_colegio: null,
        id_curso_colegio: null,
        domicilio: null,
        observaciones: null,
        profesion: null,
        fecha_inscripcion:
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          new Date().getDate(),
        id_grupo_catequesis: null,
        foto: null,
        nombre_foto: null,
        bautizo: {
          nombreParroquia: undefined,
          fecha: undefined,
          municipio: undefined,
          provincia: undefined,
          libro: undefined,
          folio: undefined,
          numero: undefined,
          entregada: 0,
        },
        situacion_familiar: null,
        padre: {
          nombre: null,
          apellido1: null,
          apellido2: null,
          fecha_nacimiento: null,
          profesion: null,
          telefono: null,
          id: null,
        },
        madre: {
          nombre: null,
          apellido1: null,
          apellido2: null,
          fecha_nacimiento: null,
          profesion: null,
          telefono: null,
          id: null,
        },
      };
    },
    cargaCatecumeno() {
      var bautizo = null;
      if (this.catecumeno.bautizo && this.catecumeno.bautizo != "") {
        bautizo = JSON.parse(this.catecumeno.bautizo);
      }
      this.modalCatecumeno = {
        id: this.catecumeno.id,
        activo: this.catecumeno.activo,
        nombre: this.catecumeno.nombre,
        apellido1: this.catecumeno.apellido1,
        apellido2: this.catecumeno.apellido2,
        fecha_nacimiento: this.catecumeno.fecha_nacimiento,
        numero_hermanos: this.catecumeno.numero_hermanos,
        lugar_ocupa_hermanos: this.catecumeno.lugar_ocupa_hermanos,
        id_colegio: this.catecumeno.id_colegio,
        id_curso_colegio: this.catecumeno.id_curso_colegio,
        domicilio: this.catecumeno.domicilio,
        observaciones: this.catecumeno.observaciones,
        profesion: this.catecumeno.profesion,
        fecha_inscripcion: this.catecumeno.fecha_inscripcion,
        id_grupo_catequesis: this.catecumeno.id_grupo_catequesis,
        foto: this.catecumeno.foto,
        nombre_foto: this.catecumeno.nombre_foto,
        bautizo: {
          nombreParroquia:
            bautizo && bautizo.nombreParroquia ? bautizo.nombreParroquia : "",
          fecha: bautizo && bautizo.fecha ? bautizo.fecha : "",
          municipio: bautizo && bautizo.municipio ? bautizo.municipio : "",
          provincia: bautizo && bautizo.provincia ? bautizo.provincia : "",
          libro: bautizo && bautizo.libro ? bautizo.libro : "",
          folio: bautizo && bautizo.folio ? bautizo.folio : "",
          numero: bautizo && bautizo.numero ? bautizo.numero : "",
          entregada: bautizo && bautizo.entregada ? bautizo.entregada : 0,
        },
        situacion_familiar: this.catecumeno.situacion_familiar,
      };
      if (this.catecumeno.padre != null) {
        this.modalCatecumeno.padre = {
          nombre: this.catecumeno.padre.nombre,
          apellido1: this.catecumeno.padre.apellido1,
          apellido2: this.catecumeno.padre.apellido2,
          fecha_nacimiento: this.catecumeno.padre.fecha_nacimiento,
          profesion: this.catecumeno.padre.profesion,
          telefono: this.catecumeno.padre.telefono,
          id: this.catecumeno.padre.id,
        };
      } else {
        this.modalCatecumeno.padre = {
          nombre: "",
          apellido1: "",
          apellido2: "",
          fecha_nacimiento: "",
          profesion: "",
          telefono: "",
          id: "",
        };
      }
      if (this.catecumeno.madre != null) {
        this.modalCatecumeno.madre = {
          nombre: this.catecumeno.madre.nombre,
          apellido1: this.catecumeno.madre.apellido1,
          apellido2: this.catecumeno.madre.apellido2,
          fecha_nacimiento: this.catecumeno.madre.fecha_nacimiento,
          profesion: this.catecumeno.madre.profesion,
          telefono: this.catecumeno.madre.telefono,
          id: this.catecumeno.madre.id,
        };
      } else {
        this.modalCatecumeno.madre = {
          nombre: "",
          apellido1: "",
          apellido2: "",
          fecha_nacimiento: "",
          profesion: "",
          telefono: "",
          id: "",
        };
      }
      this.foto = {
        isImage: this.catecumeno.foto ? true : false,
        src: this.catecumeno.foto,
        name: this.catecumeno.nombre_foto,
        type: undefined,
        document: undefined,
      };
    },
    clean(element) {
      if (element == "foto") {
        this.modalCatecumeno.foto = this.foto.src;
        this.modalCatecumeno.nombre_foto = this.foto.name;
        this.foto = {
          isImage: false,
          src: undefined,
          name: undefined,
          type: undefined,
          document: undefined,
        };
      }
    },
    async uploadFile(e) {
      const file = e.target.files[0];
      // Opciones de compresión
      const options = {
        maxSizeMB: 0.1, // Tamaño máximo en MB => 0.2 = 200KB
        maxWidthOrHeight: 800, // Redimensionar la imagen si es muy grande
        useWebWorker: true, // Usar web workers para mejorar el rendimiento
      };

      try {
        // Comprimir la imagen
        const compressedFile = await imageCompression(file, options);

        // Convertir la imagen comprimida a base64
        const base64Image = await this.convertToBase64(compressedFile);

        this.foto.isImage = true;
        this.foto.src = base64Image;
        this.foto.name = file.name;
        this.foto.type = file.type;
      } catch (error) {
        console.error("Error al comprimir la imagen:", error);
      }
    },
    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    cargaModal() {
      this.resetDatos();
      if (this.catecumeno.id) {
        this.cargaCatecumeno();
        this.isDisabled.radioPadres = true;
        this.isDisabled.padres = true;

        this.selected = 1;
        if (Array.isArray(this.optionsCurso)) {
          this.optionsCurso.forEach((element) => {
            if (Array.isArray(element.value)) {
              element.value.forEach((element2) => {
                if (element2.value == this.catecumeno.id_grupo_catequesis) {
                  this.cursoSelected = element.value;
                }
              });
            }
          });
        }
      } else {
        this.isDisabled.radioPadres = false;
      }
    },
    autoMadre(autocompleteMadre) {
      let madre = this.$store.getters.getTodasMadres.find(
        (element) =>
          element.nombre + " " + element.apellido1 + " " + element.apellido2 ==
          autocompleteMadre
      );
      if (madre) {
        this.modalCatecumeno.madre.nombre = madre.nombre;
        this.modalCatecumeno.madre.apellido1 = madre.apellido1;
        this.modalCatecumeno.madre.apellido2 = madre.apellido2;
        this.modalCatecumeno.madre.fecha_nacimiento = madre.fecha_nacimiento;
        this.modalCatecumeno.madre.profesion = madre.profesion;
        this.modalCatecumeno.madre.telefono = madre.telefono;
        this.modalCatecumeno.madre.id = madre.id;
      } else {
        this.modalCatecumeno.madre.nombre = "";
        this.modalCatecumeno.madre.apellido1 = "";
        this.modalCatecumeno.madre.apellido2 = "";
        this.modalCatecumeno.madre.fecha_nacimiento = "";
        this.modalCatecumeno.madre.profesion = "";
        this.modalCatecumeno.madre.telefono = "";
        this.modalCatecumeno.madre.id = undefined;
      }
    },
    autoPadre(autocompletePadre) {
      let padre = this.$store.getters.getTodosPadres.find(
        (element) =>
          element.nombre + " " + element.apellido1 + " " + element.apellido2 ==
          autocompletePadre
      );
      if (padre) {
        this.modalCatecumeno.padre.nombre = padre.nombre;
        this.modalCatecumeno.padre.apellido1 = padre.apellido1;
        this.modalCatecumeno.padre.apellido2 = padre.apellido2;
        this.modalCatecumeno.padre.fecha_nacimiento = padre.fecha_nacimiento;
        this.modalCatecumeno.padre.profesion = padre.profesion;
        this.modalCatecumeno.padre.telefono = padre.telefono;
        this.modalCatecumeno.padre.id = padre.id;
      } else {
        this.modalCatecumeno.padre.nombre = "";
        this.modalCatecumeno.padre.apellido1 = "";
        this.modalCatecumeno.padre.apellido2 = "";
        this.modalCatecumeno.padre.fecha_nacimiento = "";
        this.modalCatecumeno.padre.profesion = "";
        this.modalCatecumeno.padre.telefono = "";
        this.modalCatecumeno.padre.id = undefined;
      }
    },
    guardaCatecumeno() {
      swal.hideLoading();
      this.modalCatecumeno.foto = this.foto.src;
      this.modalCatecumeno.nombre_foto = this.foto.name;
      this.modalCatecumeno.bautizo = JSON.stringify(
        this.modalCatecumeno.bautizo
      );
      this.$emit("guardaCatecumeno", this.modalCatecumeno);
    },
  },
};
</script>
<style></style>
